import get from 'lodash/get';
import { createResource, type Match, type Query } from '@atlassian/react-resource-router';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { getProjectKeyId } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';
import {
	ONE_DAY_IN_MILLIS,
	RESOURCE_TYPE_SERVICEDESK_NAV3_QUEUE_GROUPS_STATE,
} from '../../constants.tsx';
import type { State } from './types.tsx';
import { getQueueGroupsStateFromUserProperty } from './user-property/index.tsx';

const getProjectKey = ({ match, query }: { match: Match; query: Query }) =>
	// projectKey from url path or browse/{issueKey}
	getProjectKeyId(match, query).projectKey || get(match, 'params.issueKey', '').split('-')[0];

export const nav3QueueGroupsStateResource = createResource<State | undefined>({
	type: RESOURCE_TYPE_SERVICEDESK_NAV3_QUEUE_GROUPS_STATE,
	getKey: getProjectKey,
	getData: async ({ match, query }, { tenantContext: { atlassianAccountId } }) => {
		if (!atlassianAccountId) {
			return undefined;
		}

		const projectKey = getProjectKey({ match, query });
		try {
			return await getQueueGroupsStateFromUserProperty(projectKey, atlassianAccountId);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireErrorAnalytics({
				error,
				meta: {
					id: 'getQueueGroupsStateInUserPropertyResourceError',
				},
			});
			return undefined;
		}
	},
	maxAge: ONE_DAY_IN_MILLIS,
});
